var map = {
	"./202409/4399.png": "1de3",
	"./202409/android.png": "6f7b",
	"./202409/appstore.png": "305c",
	"./202409/bg-mobile.png": "53b0",
	"./202409/bg-pc.png": "5f47",
	"./202409/huawei-harmonyos.png": "8e4e",
	"./202409/stream.png": "142d",
	"./202409/wegame.png": "59e1",
	"./20240923/android.png": "51e7f",
	"./20240923/appstore.png": "eeb0",
	"./20240923/bg-mobile.png": "833b",
	"./20240923/huawei-harmonyos.png": "22c2",
	"./202510/home/bg.png": "5fe6",
	"./202510/home/censor/en.png": "8de0",
	"./202510/home/censor/en1.png": "d549",
	"./202510/home/censor/logo.png": "4a76",
	"./202510/home/censor/zh.png": "c494",
	"./202510/home/shop/en/ns.png": "3fd8",
	"./202510/home/shop/en/ps.png": "0da1",
	"./202510/home/shop/ja/ns.png": "5907",
	"./202510/home/shop/ja/ps.png": "7aa2",
	"./202510/home/shop/zh/ns.png": "fd93",
	"./202510/home/shop/zh/ps.png": "fea3",
	"./202510/home/title/en/main.png": "60b0",
	"./202510/home/title/en/sub.png": "bff0",
	"./202510/home/title/ja/main.png": "2cee",
	"./202510/home/title/ja/sub.png": "9684",
	"./202510/home/title/zh/main.png": "32e9",
	"./202510/home/title/zh/sub.png": "cb63",
	"./202510/icons/en/bluesky.png": "e8f2",
	"./202510/icons/en/instagram.png": "24f6",
	"./202510/icons/en/x.png": "7c8b",
	"./202510/icons/en/youtube.png": "8d93",
	"./202510/icons/ja/bluesky.png": "74ce",
	"./202510/icons/ja/instagram.png": "6135",
	"./202510/icons/ja/x.png": "a7c0",
	"./202510/icons/ja/youtube.png": "16c7",
	"./202510/icons/zh/bilibili.png": "7352",
	"./202510/icons/zh/qq.png": "cf1d",
	"./202510/icons/zh/taobao.png": "f214",
	"./202510/icons/zh/xiaoheihe.png": "adf3",
	"./202510/role/a/a-back.png": "84d2",
	"./202510/role/a/a-bottom.png": "4340",
	"./202510/role/bl/bl-back.png": "d052",
	"./202510/role/bl/bl-bottom.png": "a895",
	"./202510/role/es/es-back.png": "eb06",
	"./202510/role/es/es-bottom.png": "b76b",
	"./202510/role/hb/hb-back.png": "b397",
	"./202510/role/hb/hb-bottom.png": "a82e",
	"./202510/role/hk/hk-back.png": "42a2",
	"./202510/role/hk/hk-bottom.png": "700d",
	"./202510/role/hzm/hzm-back.png": "c7b7",
	"./202510/role/hzm/hzm-bottom.png": "7965",
	"./202510/role/jn/jn-back.png": "211d",
	"./202510/role/jn/jn-bottom.png": "b124",
	"./202510/role/kk/kk-back.png": "c7a7",
	"./202510/role/kk/kk-bottom.png": "50a6",
	"./202510/role/ma/ma-back.png": "ebb0",
	"./202510/role/ma/ma-bottom.png": "3419",
	"./202510/role/nol/nol-back.png": "e8da",
	"./202510/role/nol/nol-bottom.png": "c202",
	"./202510/role/nt/nt-back.png": "071e",
	"./202510/role/nt/nt-bottom.png": "3ed8",
	"./202510/role/rc/rc-back.png": "c369",
	"./202510/role/rc/rc-bottom.png": "ccd3",
	"./202510/role/rg/rg-back.png": "6843",
	"./202510/role/rg/rg-bottom.png": "7bc7",
	"./202510/role/tk/tk-back.png": "8b43",
	"./202510/role/tk/tk-bottom.png": "84a0",
	"./202602/announcement/bg.png": "890f",
	"./202602/announcement/cn.png": "070b",
	"./202602/announcement/en.png": "9183",
	"./202602/announcement/jp.png": "47a3",
	"./202602/guide/bg.png": "3200",
	"./202602/home/bg.png": "1a72",
	"./202602/shop/xbox.png": "b0ca",
	"./202602/title/en/main.png": "ecb0",
	"./202602/title/en/sub.png": "621b",
	"./202602/title/ja/main.png": "4dbf",
	"./202602/title/ja/sub.png": "d8fa",
	"./202602/title/zh/main.png": "8f2d",
	"./202602/title/zh/sub.png": "ac10",
	"./202603/nav-anno/arrow.png": "d095",
	"./202603/nav-anno/bg.png": "7dba",
	"./202603/nav-anno/icon.png": "fe1c",
	"./202603/nav-anno/icon2.png": "d105",
	"./PS.png": "c310",
	"./QQ.png": "480a",
	"./a-active.png": "fb23",
	"./a-back.png": "45fd",
	"./a-bottom.png": "dbfc",
	"./a.png": "67f6",
	"./appstore-en.png": "b0a1",
	"./appstore-hk.png": "0f1c",
	"./appstore-ja.png": "e51e",
	"./appstore-zh.png": "e856",
	"./bao.png": "2ddd",
	"./bilibili-home.png": "b0c0",
	"./bilibili.png": "153a",
	"./bl-active.png": "d8d3",
	"./bl-back.png": "6cd2",
	"./bl-bottom.png": "cd40",
	"./bl.png": "d18f",
	"./btn-active.png": "ebdd",
	"./btn-hover.png": "dc99",
	"./close.png": "d991",
	"./copyright.png": "45c3",
	"./download-en.png": "342a",
	"./download-ja.png": "18f7",
	"./download-zh.png": "0149",
	"./es-active.png": "9cf9",
	"./es-back.png": "5626",
	"./es-bottom.png": "27cd",
	"./es.png": "8177",
	"./fbbz-home.png": "e0ec",
	"./haoyou-new.png": "cbe5",
	"./hb-active.png": "106a",
	"./hb-back.png": "2b6c",
	"./hb-bottom.png": "e6ef",
	"./hb.png": "44c1",
	"./hk-active.png": "d089",
	"./hk-back.png": "c70b",
	"./hk-bottom.png": "ea5a",
	"./hk.png": "a902",
	"./home-cover.png": "78b7",
	"./hzm-active.png": "af8f",
	"./hzm-back.png": "4e72",
	"./hzm-bottom.png": "48c1",
	"./hzm.png": "f176",
	"./icey-active.png": "0030",
	"./icey-back.png": "8661",
	"./icey-bottom.png": "a863",
	"./icey.png": "d46f",
	"./jn-active.png": "5b80",
	"./jn-back.png": "3e57",
	"./jn-bottom.png": "ec23",
	"./jn.png": "f192",
	"./kk-active.png": "809a",
	"./kk-back.png": "6531",
	"./kk-bottom.png": "85f1",
	"./kk.png": "4fe6",
	"./li-back.png": "acb4",
	"./ma-active.png": "83f5",
	"./ma-back.png": "2651",
	"./ma-bottom.png": "f18d",
	"./ma.png": "72db",
	"./more.png": "6664",
	"./nav-back.png": "a383",
	"./news-back.png": "acaf",
	"./news-content-back.png": "a60b",
	"./news-detail-top.png": "f5c2",
	"./news-left.png": "7d3e",
	"./news-right.png": "4cbf",
	"./nol-active.png": "4759",
	"./nol-back.png": "4cde",
	"./nol-bottom.png": "457d",
	"./nol.png": "3a68",
	"./notice.png": "5114",
	"./nt-active.png": "b6aa",
	"./nt-back.png": "7f5d",
	"./nt-bottom.png": "1840",
	"./nt.png": "c127",
	"./play-active.png": "50ea",
	"./play.png": "c4bf",
	"./qrcode/bbee-qr.png": "a10b",
	"./qrcode/bbee_logo.png": "ac65",
	"./rc-active.png": "7c4f",
	"./rc-back.png": "83a1",
	"./rc-bottom.png": "e506",
	"./rc.png": "9c7b",
	"./rg-active.png": "51e7",
	"./rg-back.png": "4547",
	"./rg-bottom.png": "b152",
	"./rg.png": "e9ad",
	"./role-back.png": "282e",
	"./role-video.png": "403b",
	"./shows-back.png": "273a",
	"./steam-en.png": "5c1b",
	"./steam-ja.png": "1cce",
	"./steam-zh.png": "3a4a",
	"./switch.png": "a698",
	"./taptap-home.png": "6a26",
	"./taptap.png": "16fe",
	"./title-de1.png": "4523",
	"./title-de2.png": "1563",
	"./title-en.png": "fdb8",
	"./title-ja.png": "0bd5",
	"./title-zh.png": "338b",
	"./title2-en.png": "d558",
	"./title2-ja.png": "17b1",
	"./title2-zh.png": "ade8",
	"./tk-active.png": "6e5a",
	"./tk-back.png": "fd29",
	"./tk-bottom.png": "b69f",
	"./tk.png": "013f",
	"./video-back.png": "72e6",
	"./video-left.png": "23a9",
	"./video-right.png": "0b8a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";